module.exports = __webpack_public_path__ + "img/Banner-FLE-WLB.40b9d2d0.png";